import { Model } from "@chaysehartsuff/active-html";

/**
 * PublicMessage model
 */
export default class PublicMessage extends Model {
    id
    name;
    message;
    email;
    needs_review;
    session_token;
    current_session_token;
    reply_to_id;
    admin_id;
    user_owns;
    created_at;
    updated_at;
}